import AuthPage from '../components/AuthPage.tsx';
import { useTranslation } from 'react-i18next';
import Button from '../../core/components/Button.tsx';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import classnames from '../../core/utils/classnames.tsx';
import { useQuery } from '@apollo/client';
import { GET_MFA_DEVICES } from '../../users/queries.ts';
import Alert from '../../core/components/Alert.tsx';
import { Link } from 'react-router';
import { safeInternalUrl, url } from '../../core/utils/link.ts';
import { SETUP_MFA_PATH } from '../constants.ts';
import MfaForm from '../../users/components/MfaForm.tsx';

const SetupMfaRecoveryPage = () => {
    const { t } = useTranslation('user');

    const [searchParams] = useSearchParams();
    const nextLocation = safeInternalUrl(searchParams.get('next'));

    const { data: mfaDevices, refetch } = useQuery(GET_MFA_DEVICES);
    const recoveryCodeDevices = mfaDevices?.mfaDevices.filter((device) => device.deviceType === 'static');
    const hasRecoveryCodes = recoveryCodeDevices && recoveryCodeDevices.length > 0;

    const handleDevicesChange = async () => {
        await refetch();
    };

    return (
        <AuthPage>
            <AuthPage.Content className="max-w-[50rem]">
                <AuthPage.Card className="max-w-[40rem]">
                    <AuthPage.Title>{t('setupMfaRecovery.title')}</AuthPage.Title>

                    <p className="text-content-strong">{t('setupMfaRecovery.description')} </p>

                    <MfaForm hideWebauthn hideTotp onDevicesChange={handleDevicesChange} />

                    <Alert severity="warning">{t('setupMfaRecovery.warningAlert')}</Alert>

                    <div className="flex justify-between gap-2">
                        <Button variant="ghost" className="text-content-brand-strong" asChild>
                            <Link to={url(SETUP_MFA_PATH, undefined, { search: { next: nextLocation } })}>
                                {t('setupMfaRecovery.goBackButton')}
                            </Link>
                        </Button>

                        <Button
                            variant="primary"
                            asChild
                            className={classnames(
                                'hover:!bg-surface-brand-strong-hover focus:!bg-surface-brand-strong-focus active:!bg-surface-brand-strong-active'
                            )}
                            disabled={!hasRecoveryCodes}
                            onClick={(e) => {
                                if (!hasRecoveryCodes) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    e.currentTarget.blur();
                                }
                            }}
                        >
                            <a href={nextLocation}>{t('setupMfaRecovery.continueButton')}</a>
                        </Button>
                    </div>
                </AuthPage.Card>
            </AuthPage.Content>
        </AuthPage>
    );
};

export default SetupMfaRecoveryPage;
